import { Injectable } from '@angular/core';
import { AwsRum, AwsRumConfig } from 'aws-rum-web';
import { environment } from '../../../environments/environment';

@Injectable({
  providedIn: 'root',
})
export class InsightService {
  private awsRum?: AwsRum;

  constructor() {
    // Don't initialize AWS RUM here - wait for initializeRum() to be called
    // after verifying the user is not a developer
  }

  /**
   * Initialize AWS RUM. Should only be called for non-developer users.
   */
  initializeRum(): void {
    if (this.awsRum || !environment?.awsrum?.enabled) {
      return;
    }

    try {
      const config: AwsRumConfig = {
        allowCookies: true,
        enableXRay: true,
        endpoint: `https://dataplane.rum.${environment.awsrum.region}.amazonaws.com`,
        guestRoleArn: environment.awsrum.guestRoleArn,
        identityPoolId: environment.awsrum.identityPoolId,
        sessionSampleRate: 1,
        sessionEventLimit: 0, // Unlimited session events
        disableAutoPageView: true, // We will manually call recordPageView
        telemetries: [
          ['errors', { stackTraceLength: 500 }],
          'performance',
          [
            'http',
            {
              stackTraceLength: 500,
              addXRayTraceIdHeader: true,
              recordAllRequests: true,
            },
          ],
        ],
      };

      this.awsRum = new AwsRum(
        environment.awsrum.applicationId,
        '1.0.0',
        environment.awsrum.region,
        config,
      );
    } catch {
      // Ignore errors thrown during CloudWatch RUM web client initialization
    }
  }

  addCustomContext(key: string, value: string | number | boolean) {
    if (this.awsRum) {
      this.awsRum.addSessionAttributes({ [key]: value });
    }
  }

  recordError(error: Error) {
    if (this.awsRum) {
      this.awsRum.recordError(error);
    }
  }

  recordPageView(pageTitle: string) {
    if (this.awsRum) {
      this.awsRum.recordPageView(pageTitle);
    }
  }
  setAwsRum(awsRum: AwsRum) {
    this.awsRum = awsRum;
  }
}
